import { FormFieldKeyActionEnum } from "../_common/enum/forms/formFieldKeyAction.enum";
import { IFormTemplateSectionManage } from "../_common/models/formTemplateSection";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "formTemplateSection";

export const formTemplateSectionService = {
    get,
    getForm,
    getAll,
    post,
    put,
    updateForm,
    disable,
    submit(model?: IFormTemplateSectionManage) { return model?.id ? put(model) : post(model) }
};

function get(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/get/?id=${id}`, requestOptions).then(handleResponse);
}

function getForm(formTemplateSectionId: number, formId: number, isForReview?: boolean, actionId?: FormFieldKeyActionEnum) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getForm/?formTemplateSectionId=${formTemplateSectionId}&formId=${formId}&isForReview=${!!isForReview ? "true" : "false"}&actionId=${actionId?.toString()||""}`, requestOptions).then(handleResponse);
}


function getAll(formTemplateId: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAll/?formTemplateId=${formTemplateId}`, requestOptions).then(handleResponse);
}

function post(model?: IFormTemplateSectionManage) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}`, requestOptions).then(handleResponse);
}

function put(model?: IFormTemplateSectionManage) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}`, requestOptions).then(handleResponse);
}

function updateForm(model?: IFormTemplateSectionManage) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}/updateForm`, requestOptions).then(handleResponse);
}

function disable(id: number) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/${id}`, requestOptions).then(handleResponse);
}